import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * `?highlight=<id>` trên một trang danh sách: tô sáng và cuộn tới đúng dòng đó (#19683).
 *
 * <p>Dùng khi một màn khác chỉ biết ID mà không có trang chi tiết riêng để mở — vd. Audit log trỏ
 * tới bác sĩ / phòng / khoa. Không có tham số thì trang hiện như cũ.
 */
export const HIGHLIGHT_PARAM = "highlight";

export const HIGHLIGHT_ROW_CLASS =
  "bg-amber-50 ring-2 ring-inset ring-amber-400 dark:bg-amber-950/40";

export function useHighlightRow() {
  const [params] = useSearchParams();
  const highlightId = params.get(HIGHLIGHT_PARAM);
  // Callback ref: chạy đúng lúc dòng được gắn vào DOM, kể cả khi dữ liệu về sau lần vẽ đầu.
  const scrollRef = useCallback((el: HTMLElement | null) => {
    el?.scrollIntoView?.({ block: "center" });
  }, []);
  const isHighlighted = useCallback(
    (rowId: string) => highlightId != null && highlightId === rowId,
    [highlightId],
  );
  return { highlightId, isHighlighted, scrollRef };
}
